<template>
  <v-dialog v-model="dialogLogin" persistent max-width="500px" max-height="600px" style="overflow-y: hidden !important;">
    <v-card >
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai">
           <span class="headline CSChatThai">
              <v-icon color="white">assignment_ind</v-icon>&nbsp;&nbsp;ยืนยันตัวตน
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">



          <v-container grid-md text-xs-center>
            <v-layout row style="align-items: center;" justify-center = true>
              <!-- <v-flex sm2 md2 lg2 xl2></v-flex> -->
              <v-flex sm12 md12 lg12 xl12  v-if="progress">
                <v-progress-circular v-if="progress" :size="250" :width="10" style="margin: auto;" indeterminate color="blue"></v-progress-circular>
              </v-flex>
              <v-flex sm12 md12 lg12 xl12 v-else>
                  <v-layout row style="justify-content: center;" v-if="type=='first'">
                  <v-card class="elevation-24" flat style="margin: 0px; border-radius: 10px; background: #2562ae;" >
                    <v-card-title primary-title>
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
                    <p style="color: white;font-weight: bold;">ยินดีต้อนรับเข้าสู่ OneChat <br/>กรุณาเลือกรูปแบบการลงชื่อเข้าใช้งาน</p>
                     <v-btn class="btnloginwebOneid" @click="type='username'">เข้าสู่ระบบด้วย OneID</v-btn>

                     <span class="textor">  หรีอ  </span>

                     <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วยเบอร์โทรศัพท์</v-btn>
                   </div>
                 </v-card>
               </v-layout>
                <v-layout row style="justify-content: center;" v-else-if="type=='phone'">
                  <v-card class="elevation-24" flat style="margin: 0px;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title>
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
               <v-text-field
                        solo
                        label="เบอร์โทรศัพท์"
                        v-model="phone"
                        class="CSChatThai"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="otp()"
                        mask="###-###-####"
                        prepend-inner-icon="phone"
                      ></v-text-field>

                     <v-btn class="btnloginwebOneid" @click="otp()" :disabled="phone === ''" :loading="loading" style="margin-bottom: 30px;width: 40%;">ขอ OTP</v-btn>
                   </div>
                   <span class="textor">  หรีอ  </span>
               <v-btn class="btnloginwebOneid_white" @click="type='username'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วย OneID</v-btn>
                 </v-card>

           </v-layout>
              <!-- <v-flex sm8 md8 lg8 xl8 v-else-if="type=='otp'"> -->
                <v-layout row style="justify-content: center;" v-else-if="type=='otp'">
                <v-flex sm12 md12 lg12 xl12>
                  <v-card class="elevation-24" flat style="margin: 0px;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title>
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
                    <p style="color: white;">เบอร์โทร: {{phone}}</p>
                    <p style="color: white;" v-if="Refcode">Refcode: {{Refcode}}</p>
                    <v-layout row justify-center align-center>
                    <v-flex sm8 md8 lg8 xl8>
                      <v-text-field
                        solo
                        label="otp"
                        v-model="otpCode"
                        class="CSChatThai"
                        maxlength="6"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="loginWithotp()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex sm4 md4 lg4 xl4>
                      <v-btn depressed class="btnloginwebOneid_white" style="width: 40%; margin-top: -24px !important;" :disabled="counting" @click="otp()">
                          <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                          <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
                        </countdown>
                        <span v-if="!counting">ส่ง OTP </span>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                     <v-btn class="btnloginwebOneid" @click="loginWithotp()" :disabled="otpCode.length != 6" style="margin-bottom: 30px;width: 40%;">เข้าสู่ระบบ</v-btn>
                     <!-- <br/> -->
                     <!--  <span class="textor">  หรีอ  </span>
               <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วย OneID</v-btn>
 -->
                   </div>
                    <span class="textor">  หรีอ  </span>
               <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วย OneID</v-btn>
                 </v-card>
             </v-flex>
           </v-layout>
              <!-- </v-flex> -->

                <v-layout row style="justify-content: center;" v-else-if="type=='username'">
                  <v-card class="elevation-24" flat style="margin: 0px;border-radius: 10px; background: #2562ae;">
                    <v-card-title primary-title>
                     <v-layout row align-center justify-center>
                        <div class="headline Kanit">
                          <img src="/static/img/icons/logoonechat_full-white.png" style="height: 70px;">
                        </div>
                      </v-layout>
                    </v-card-title>
                   <div style="padding:0px 15%; color: black;">
                     <v-form v-model="valid">

                      <v-text-field
                        solo
                        label="ชื่อผู้ใช้งาน"
                        v-model="username"
                        class="CSChatThai"
                        style="text-align:center; color: white !important;"
                        @keyup.enter="login()"
                        @keypress="isNumandaz($event)"
                        prepend-inner-icon="person"
                      ></v-text-field>

                        <v-text-field
                        solo
                        label="รหัสผ่าน"
                        v-model="password"
                        class="CSChatThai"
                        :type="showPassword ? 'text' : 'password'"
                        style="text-align:center;"
                        @keyup.enter="login()"
                        @keypress="isnotthai($event)"
                        prepend-inner-icon="lock"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>

                        <div v-if="status == 'fail' " style="color: #f9a1a1;  width: 100%;"><v-icon style="color: #f9a1a1;">info</v-icon> {{failmessage}} </div>
                         <v-btn class="btnloginweb" @click="login()">เข้าสู่ระบบ</v-btn>
                    <!--    <div style="padding-top:1vh;text-align: center;">
                     <p class="CSChatThai" style="text-align: right;"><b><span class="forgetpass" @click="open_link('https://one.th/type_forgot_password')">ลืมรหัสผ่าน?</span></b></p>
                       </div> -->
                     </v-form>
                     <span class="textor">  หรีอ  </span>
                     <v-btn class="btnloginwebOneid_white" @click="type='phone'" style="margin-bottom: 30px;">เข้าสู่ระบบด้วยเบอร์โทรศัพท์</v-btn>
                   </div>
                 </v-card>
               </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import Vue from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'
import Navbar from '@/components/homepage/Navbar'
// import NewFooter from '@/components/home/NewFooter'
// import Vue from 'vue'
import { Encode, Decode } from '@/services'
import { sync } from 'vuex-pathify'
// import VueSocketio from 'vue-socket.io'
var _ = require('lodash')
Vue.component(VueCountdown.name, VueCountdown)
export default {
  props: {
    dialogLogin: Boolean
  },
  data () {
    return {

      usernameRules: [
        v => this.regular_username_mobile()
      ],
      passwordRules: [
        v => this.regular_pass_mobile()
      ],
      valid: '',
      username: '',
      password: '',
      status: '',
      friend: '',
      status_login: '',
      progress: false,
      failmessage: 'ชื่อผู้ใช้งาน หรือ รหัสผ่าน ไม่ถูกต้อง',
      webdev: process.env.WEBchatdev,
      showPassword: false,
      url_redirect: process.env.AuthenOneid,
      validmobile: '',
      type: 'first',
      phone: '',
      otpCode: '',
      Refcode: '',
      mobile_ref_id: '',
      type_otp: '',
      counting: false,
      loading: false
    }
  },
  computed: {
    ...sync('*')
  },
  created () {

  },
  mounted () {
    if(localStorage.tologin){
      this.type = 'phone'
      this.phone = localStorage.tologin
    }
  },
  methods: {
    open_link (link) {
      window.open(link, '_blank')
    },
    closeDialog () {
      this.progress = false
      this.phone = ''
      this.username = ''
      this.password = ''
      this.type='first'
      this.$emit('closeLoginDialog', false)
    },
    handleCountdownEnd () {
      this.OTP = ''
      this.counting = false
    },
    otp () {
      this.loading = true
      this.axios.post(process.env.APImanage + '/otp_login_and_regis', {phone: this.phone, type: 'login'}).then((response) => {
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          if (response.data.type_otp == 'login') {
            this.loading = false
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type="otp"
          } else {
            this.loading = false
            this.phone = ''
            this.$swal(
              'ขออภัย!',
              'หมายเลขโทรศัพท์นี้ยังไม่ได้รับการลงทะเบียน กรุณาลงทะเบียนหรือกรอกหมายเลขโทรศัพท์อื่น',
              'error'
            )
          }
        } else if(response.data['message'] === 'No JSON object could be decoded') {
          this.loading = false
          this.$swal(
            'ขออภัย!',
            'หมายเลขโทรศัพท์นี้ร้องขอ otp บ่อยเกินไป กรุณารอซักครู่แล้วเริ่มทำรายการใหม่',
            'error'
          )
        } else {
          this.status = 'fail'
          this.progress = false
          // this.type='first'
          this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.type='first'
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    loginWithotp () {
      this.progress = true
      var source = {type_otp: this.type_otp, phone: this.phone, otp: this.otpCode, mobile_ref_id: this.mobile_ref_id}
      this.axios.post(process.env.APImanage + '/login_and_regis', source).then((response) => {
        this.status = response.data['status']
        // console.log(response.data)
        if (this.status === 'success') {
          var profile = response.data['account']['profile']
          this.myprofilepicture = profile['profilepicture']
          this.myname = profile['name']
          this.$cookie.set('language', 'th')
          localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
          localStorage.setItem('profilepicture', profile['profilepicture'])
          localStorage.setItem('name', profile['name'])
          localStorage.setItem('phone', profile['phone'])
          localStorage.setItem('email', profile['email'])
          localStorage.setItem('status', profile['status'])
          localStorage.setItem('type_user', profile['type'])
          if (profile['username'] === '' || profile['username'] === 'None') {
            localStorage.setItem('status_username', 'false')
          } else {
            localStorage.setItem('status_username', 'true')
          }
          this.progress = false
          if (localStorage.getItem('pathRoom') === '' || localStorage.getItem('pathRoom') === null) {
            this.$router.push('/chat')
          } else {
            this.$router.push(localStorage.getItem('pathRoom'))
          }
          localStorage.removeItem("tologin")
          localStorage.removeItem("tologin_keep2")
        } else {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          this.$swal(
            'ขออภัย!',
            'กรอกรหัส OTP ไม่ถูกต้อง',
            'error'
          )
        }
        // this.status = response.data['status']
        if (this.status === 'success') {
          this.closeDialog()
        } else {
          this.$cookie.set('status_login', 'F')
          this.progress = false
          this.$swal('ขออภัย!', 'กรอกรหัส OTP ไม่ถูกต้อง', 'error')
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    loginRedirect () {
      this.progress = true
      window.open(this.url_redirect, '_parent')
    },
    redirectUrl (url) {
      try {
        var link = document.getElementById("iframename").contentWindow.location.href
        // console.log(link)
        // console.log(_.includes(link, [process.env.redirect_url]))
        if(_.includes(link, [process.env.redirect_url])) {
          window.open(link + '&passlogin=true','_parent')
        }
      } catch(err) {
        console.log(err)
      }
    },
    regular_username_mobile () {
      // var str = this.username
      this.username = this.username.replace(/[^a-z-0-9@.]/i, '')
      this.username = this.username.toLowerCase()
    },
    regular_pass_mobile () {
      this.password = this.password.replace(/^[ก-๛]+/i, '')
    },
    isNumandaz ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122) && (keyCode != 46) && (keyCode != 64)) { // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai ($event) {
      // console.log($event)
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if ((keyCode >= 3585 && keyCode <= 3642) || (keyCode >= 3647 && keyCode <= 3675)) { // 46 is dot
        $event.preventDefault();
      }
    },
    toNewTab () {
      window.open(this.webdev, '_parent').focus()
    },
    toPage (page) {
      this.$router.push(page)
    },
    isMobile () {
      if ($('#mobile').is(':hidden')) {
        return false
      } else {
        return true
      }
    },
    login () {
      var addyear = 10
      var newDate = new Date()
      newDate.setTime(newDate.getTime() + (addyear*365*24*60*60*1000))
      var expiresInTime = "expires="+ newDate.toUTCString()

      if (this.username === '' || this.password === '') {
        this.failmessage = 'กรุณากรอกชื่อผู้ใช้งานและรหัสผ่าน.'
      } else {
        this.progress = true
        var source = Encode.encode({'username': this.username, 'password': this.password})
        this.axios.post(process.env.APImanage + '/loginuserwithbusiness', {source: source}).then((response) => {
          // console.log(response.data)
          this.status = response.data['status']

          var profile = response.data['account']['profile']
            this.myprofilepicture = profile['profilepicture']
            this.myname = profile['name']
            this.$cookie.set('language', 'th')
            localStorage.setItem('Authenrization', Encode.encode({'tokenuser': profile['tokenuser'], 'status_login': 'T', 'type_user': profile['type']}))
            localStorage.setItem('profilepicture', profile['profilepicture'])
            localStorage.setItem('name', profile['name'])
            localStorage.setItem('phone', profile['phone'])
            localStorage.setItem('email', profile['email'])
            localStorage.setItem('status', profile['status'])
            localStorage.setItem('type_user', profile['type'])
            if (profile['username'] === '' || profile['username'] === 'None') {
              localStorage.setItem('status_username', 'false')
            } else {
              localStorage.setItem('status_username', 'true')
            }

          if (this.status === 'success') {
            this.closeDialog()
          } else {
            this.$cookie.set('status_login', 'F')
            this.progress = false
            if (response.data['message'] === 'Wrong Username / Password') {
              this.failmessage = 'ชื่อผู้ใช้งานหรือรหัสผ่านผิด กรุณาตรวจสอบใหม่อีกครั้ง.'
            } else {
              this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
            }
          }
        }, (error) => {
          console.log(error)
          this.status = 'fail'
          this.progress = false
          this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
        })
      }
    },
    searchFriend (botid) {
      // console.log(`bot id : ${localStorage.getItem('botid_redirect')}`)
      if (localStorage.getItem('botid_redirect') !== null) {
        this.progress = true
        var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        this.axios.post(process.env.APIsearchfriend, {
          tokenbot: botid,
          tokenuser: decoded.tokenuser
        }).then((response) => {
          this.progress = false
          // console.log(response.data.listuser)
          if (response.data.listuser.length === 0) {
            if (window.innerWidth <= 960) {
              this.$router.push('/mobile/homepage')
            } else {
              this.$router.push('/chat')
            }
          } else {
            if (response.data.listuser.relation === 'friend') {
              localStorage.removeItem('botid_redirect')
              if (this.isMobile()) {
                this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom)
              } else {
                this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom)
              }
            } else {
              console.log('not friend')
              this.$router.push('/addbot/' + localStorage.getItem('botid_redirect'))
            }
          }
        }).catch(error => {
          console.log(error)
          localStorage.removeItem('botid_redirect')
          this.progress = false
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (window.innerWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        })
      }
    },
  },
  components: {
    Navbar
  }
}
</script>
<style type="text/css" scoped>
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.v-messages__message {
  margin-bottom: 2px;
  margin-top: 2px;
  line-height: 1;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}
>>>.error--text {
  color: #ff7979 !important;
  caret-color: #ff7979 !important;
}
.forgetpass {
  color: white !important;
  cursor: pointer !important;
}
.forgetpass:hover {
  color: white !important;
  cursor: pointer !important;
  text-decoration: underline !important;
}
a:link {
    text-decoration: none;
    color: white !important;
}

a:visited {
    color: white !important;
    text-decoration: none;
}

a:hover {
    color: #2562af !important;
    text-decoration: none;
}

a:active {
    color: white !important;
    text-decoration: none;
}
.footer {
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: white !important;
   color: white;
   text-align: center;
}
.footermo {
   left: 0;
   bottom: 0;
   width: 100%;
   background-color: #00000000 !important;
   color: white;
   text-align: center;
   margin-top: 20px;
}
.application .theme--light.card, .theme--light .card {
    background-color:  #2562af !important;
}
html, body {
  overflow: scroll;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.btnloginmobile {
  /* width: 30%; */
  width: 125px !important;
  font-size: 14px;
  color: white !important;
  margin-top: 1vh !important;
  background-color: #2562af!important;
  border: 2px solid white;
  border-radius: 30px;
}
.btnloginmobile:disabled {
  width: 125px !important;
  font-size: 14px;
  /* color: white !important; */
  margin-top: 1vh !important;
  background-color: #5f9cea !important;
  border-radius: 30px;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  border-color: #5e9cea !important;
  background-color: #5f9cea!important;
}

.btnloginweb {
  color: white !important;
  width:40%;
  margin-top: 1vh !important;
  background-color: #2562af !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
.btnloginwebOneid {
  color: white !important;
  margin-top: 1vh !important;
  width:80%;
  background-color: #2562af !important;
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
.btnloginwebOneid_white {
  color: #2562af !important;
  margin-top: 1vh !important;
  width:80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid #2562af;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}

.textor {
  color: white;
}

.textor:after,
.textor:before{
    content:"\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
    text-decoration:line-through;
    color: white;
}


>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12) !important;
    border-radius: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/LoginDialog.vue